import { useAuth } from '../hooks/useAuth';
import signoutIcon from '../assets/signout-icon.svg';

export default function LogoutLink({ className }) {
  const { signout } = useAuth();

  return (
    <button
      type="button"
      onClick={signout}
      className={`text-gray-400 flex ${className ? className : ''}`}
    >
      <img className="mr-1 opacity-70" src={signoutIcon} alt="logout icon" />{' '}
      Logout
    </button>
  );
}
